/**
 * Generate a single string which is the concatenation of a name and a surname, separated by a blank space
 * @example
 * nameAndSurnameConcatenater(simon,periquet)
 * ==> 'simon periquet'
 * @param name `string`
 * @param surname `string`
 * @returns `string` - concatenated string
 */
export function nameAndSurnameConcatenater(name: string, surname: string): string {
  if (typeof name !== 'string' || typeof surname !== 'string') return '';

  return `${name ? name + ' ' : name}${surname}`;
}
